import * as angular from "angular";

angular
  .module('bringoz.admin.configuration-profiles')
  .config(configurationProfilesConfig);

/* @ngInject */
function configurationProfilesConfig() {

}
